import { render, staticRenderFns } from "./FiltersAvhandlingar.vue?vue&type=template&id=4b645b6a&scoped=true&"
import script from "./FiltersAvhandlingar.vue?vue&type=script&lang=js&"
export * from "./FiltersAvhandlingar.vue?vue&type=script&lang=js&"
import style0 from "./FiltersAvhandlingar.vue?vue&type=style&index=0&id=4b645b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b645b6a",
  null
  
)

export default component.exports